import React from 'react'
import ReactDOM from 'react-dom'
import TouchButton from '../../utils/ope-touch-button'
import createReactClass from 'create-react-class'


/**
 * Display the batch "Edit all" button
 */
var EditAll = createReactClass({
	render: function() {
		var className = "ope-button ope-button--no-border l-right",
			icon = this.props.expanded ? "ope-edit-all-icon-open" : "ope-edit-all-icon-closed",
			iconClass = "ope-icon " + icon;
		return (
			<TouchButton className={className} onTap={this.props.callback} id="editAllButton">
				{this.props.expanded ? _("Done") : _("Edit all") }
				<span className={iconClass}></span>
			</TouchButton>
		);
	}
});

export default EditAll;
